import { createStyles, makeStyles, TextFieldProps } from '@material-ui/core';
import React from 'react';

import { BaseTextField } from './BaseTextField';

const useStyles = makeStyles(() =>
  createStyles({
    textAreaContainer: {
      '& textarea': {
        resize: 'vertical',
      },
    },
  }),
);

/**
 * @description This is deprecated. Please use the new ResizableTextField component in src/components/textfield/ResizableTextField.tsxtsx
 * @deprecated use the new component in src/components/textfield/ResizableTextField.tsxtsx
 */

export const ResizableTextField: React.FC<TextFieldProps> = (props) => {
  const classes = useStyles();
  return (
    <BaseTextField
      className={classes.textAreaContainer}
      fullWidth
      multiline
      minRows={2}
      maxRows="Infinity"
      {...props}
    />
  );
};
